import { atom } from "jotai"

import type { TCart } from "~/managers/CartManager/_data/serializer"

export const cartAtom = atom<TCart | null>(null)
